/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/106-forward': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M4.096 0C2.319 3.219 2.02 8.13 9 7.966V4l6 6-6 6v-3.881C.641 12.337-.29 4.741 4.096 0z"/>'
  }
})
